module.exports = __webpack_public_path__ + "fonts/Lato-SemiboldItalic.d5fa302e.ttf";